import Actions      from "../../model/constant/actions"
import ReducerUtils from "../../utils/ReducerUtils"
import Vehicle      from "../../model/Store/Vehicle/Vehicle"

interface state{
  [accountId:number] : Vehicle[]
}

const retrieveInventoryForAccount = (state,action) =>{
  return {...state,[action.accountId]:action.inventory}
}

export const InventoryList = ReducerUtils.createReducer<state>({},{
  [Actions.RETRIEVE_INVENTORY_FOR_ACCOUNT]          : retrieveInventoryForAccount,
})
